import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const HEADERANCHORLISTBLOCK_LEGACY_FIELD_ORDER = [];

const {
  headerAnchorListBlockDescriptor: _generatedHeaderAnchorListBlockDescriptor,
  headerAnchorListBlockBlocDefinition,
  headerAnchorListBlockDashboardLayout,
  headerAnchorListBlockConfig,
  headerAnchorListBlockResolveConfig,
  headerAnchorListBlockProperties,
} = doodBlockConfig(
  {
    name: "Header Anchor - list",
    componentType: 'HeaderAnchorListBlockComponent',
    category: 'navigation',
    description: "Header Anchor - list.",
    keywords: [],
    allowedIn: [
      { bloc: "HeaderBlockComponent", slot: "left_blocks" },
      { bloc: "HeaderBlockComponent", slot: "navigation_links" },
    ],
    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function headerAnchorListBlockDescriptor(): IBlockDescriptor;
export function headerAnchorListBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function headerAnchorListBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedHeaderAnchorListBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedHeaderAnchorListBlockDescriptor, headerAnchorListBlockProperties, fieldOrder);
}

export {
  headerAnchorListBlockBlocDefinition,
  headerAnchorListBlockDashboardLayout,
  headerAnchorListBlockProperties,
  headerAnchorListBlockConfig,
  headerAnchorListBlockResolveConfig,
};

export type HeaderAnchorListBlockConfig = typeof headerAnchorListBlockConfig;
